module.exports = __webpack_public_path__ + "static/media/cases_3d_03c.b4e9a623.jpg";